<template>
	<div grey-back>

		<!-- <v-toolbar flat fixed dense noborder class="nopadding">
			<v-toolbar-title font14 style="text-transform: uppercase;height: 56px;line-height: 56px;border-bottom: 2px #4b77be solid;padding: 0px 16px;font-weight:500!important">Reports</v-toolbar-title>
			<v-text-field flat solo placeholder="Search..." v-model="searchValue" slot="extension"></v-text-field>
    	</v-toolbar>

    	<v-divider></v-divider> -->

	    <div grey-back>
	    	<template v-for="(group, index) in filteredItems">
	    		<v-list nopadding class="mb-2" subheader :key="index" v-if="group.items && group.items.length && fn_hideReportGroup(group)" :data-no-translate="group.groupName === 'GST Reports' ? '' : null">
		          <v-subheader subheader-semi-dense light>{{group.groupName}}</v-subheader>
		          <v-divider></v-divider>
		          <div v-for="(item, itemIndex) in group.items" :key="itemIndex" v-if="fn_hideReport(item.reportId)">
	          		<v-list-tile @click="fn_goto(item.reportId)">
			            <v-list-tile-content>
			              	<v-list-tile-title v-html="item.name"></v-list-tile-title>
			            </v-list-tile-content>
			        </v-list-tile>
			        <v-divider v-if="group.items.length-1 != itemIndex"></v-divider>
		          </div>
		        </v-list>
	    	</template>
	    	

	    </div>
	</div>
</template>

<script>

let tagId = 'reports'

	export default{
		name: 'report_list',
		data(){
			return{
				reportGroups:require('../../../../config.js').configs.reportList,
				scrollPositionTop:0,
				error:null,
				show:false,
				loading:false,
				searchValue:''
			}
		},
		methods:{

			fn_hideReportGroup: function(group){
				if(this.$root.CurrentBusiness.GSTRegistrationStatus==3 && group.groupName == 'GST Reports')
					return false;
				else
					return true;
			},
			fn_hideReport: function(reportId){
				if(this.$root.CurrentBusiness.GSTRegistrationStatus==1 && (reportId == 804))
					return false;
				else if(this.$root.CurrentBusiness.GSTRegistrationStatus==2 && (reportId == 303 || reportId == 801 || reportId == 802 || reportId == 803 || reportId == 312))
					return false;
				else if(this.$root.CurrentBusiness.GSTRegistrationStatus==3 && (reportId == 303 || reportId == 312))
					return false;
				else if(!this.$root.TransactionSettings.branchDivision && (reportId == 306 || reportId == 307 || reportId == 407 || reportId == 408))
					return false;
				else if(!this.$root.TransactionSettings.enableBatch && (reportId == 105 || reportId == 109))
					return false;
				else if(this.$root.appVersion < 209 && (reportId == 108 || reportId == 109))
					return false;
				else if(this.$root.appVersion < 230 && reportId == 204) 
					return false;
				else if(reportId == 606 && (this.$root.appVersion < 234 || !this.$root.TransactionSettings.enablePrescribeDetails))
					return false;
				else if(reportId == 415 && !this.$root.TransactionSettings.enableSalesman)
					return false;
				else if(reportId == 416 && !this.$root.TransactionSettings.enableBroker)
					return false;
				else if(reportId == 110 && !this.$root.TransactionSettings.lowStockAlert)
					return false;
				else if(!this.$root.TransactionSettings.enableGodown && (reportId == 207 || reportId == 208))
					return false;
				else if(this.$root.appVersion < 297 && (reportId == 205 || reportId == 310 || reportId == 104 || reportId == 604 || reportId == 110 || reportId == 206 || reportId == 207 || reportId == 208))
					return false;
				else
					return true;
			},

		    fn_goto: function(reportid){
		    	this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+reportid});
		    },

		    fn_showBottomNavigation: function () {

		        let self = this;

		        let navigationObject = {activeIndex: 1001};

		        console.log('show navigation');

		        this.showBottomNavigation(tagId, navigationObject, 
		          {
		            onSuccess: function(response){
		              console.log(response);
		            }, 
		            onError: function(error){
		              console.log(error);
		            }, 
		            // onChange: null, 
		            onMenuItemClick: function (tagId, menuId, menuAction) {
		              self.$root.fn_bottomNavigationItemClick(tagId, menuId, menuAction)
		            }
		          }
		        );
		    },

		    fn_hideBottomNavigation: function () {

		        this.hideBottomNavigation({
		            onSuccess: function(response){
		              console.log(response);
		            }, 
		            onError: function(error){
		              console.log(error);
		            }
		          }
		        );

		    },

		    fn_showWebView: function () {
		        this.showWebView(tagId, {}, 
		          {
		            onSuccess: function(response){
		              console.log(response);
		            }, 
		            onError: function(error){
		              console.log(error);
		            }, 
		          }
		        );
		    }
	  	},

	  // 	mounted: function(){
	  // 		let self = this;
	  // 		document.addEventListener('scroll', function () {
			// 	self.scrollPositionTop = window.pageYOffset
			// });

	  // 		AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));
	  // 		window.js_globals.fn_onBackPress = this.exitApp;
	  // 	},
	  	computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        let groups = JSON.parse(JSON.stringify(this.reportGroups));

		        return groups.filter(group => {
		        	return group.items = group.items.filter(item => {
		        		let fieldName = item.name.toLowerCase();
		        		return fieldName.match(searchText);
		        	})
		        })
		        
		     }
		}

	 //  	beforeRouteLeave (to, from , next) {
	 //      if(to.name!="reports" && to.name!="activitytabs" && to.name!="actions" && to.name!="notifications" && to.name!="settings"){
	 //        this.fn_hideBottomNavigation();
	 //      }
	 //      next();
	 //    },

		// beforeRouteEnter(to, from, next){
		// 	 next(vm => {
		//         if(from.name!="reports" && from.name!="activitytabs" && from.name!="actions" && from.name!="notifications" && from.name!="settings"){
		//             vm.fn_showWebView();
		//         }

		//         vm.fn_showBottomNavigation();
		//     })
	 //    },
	}
</script>


// WEBPACK FOOTER //
// src/components/newreports/dashboard/contents/reportlist.vue